export default "/view/img/461c9e91860ed8583e6ea46b39f687c3.jpg";